module.exports = __webpack_public_path__ + "img/34.2.TN.bd85d7c9.png";